import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@/shared/styles/globals.css";
import { ThemeProvider } from "@/shared/theme/ThemeProvider";
import { AppProviders } from "@/providers/AppProviders";
import { AppRoutes } from "@/routes/AppRoutes";
import { iniciarCapturaInstalacaoPwa } from "@/shared/hooks/usePwaInstall";

// PWA: guarda o aviso de instalação do navegador desde o primeiro carregamento (ver usePwaInstall.ts).
iniciarCapturaInstalacaoPwa();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Elemento #root não encontrado em index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <AppProviders>
        <AppRoutes />
      </AppProviders>
    </ThemeProvider>
  </StrictMode>,
);

// PWA: registra o service worker (ver public/sw.js — não cacheia o app em
// si, só o shell de ícones, para nunca deixar usuários presos em versão
// antiga após um deploy).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Falha silenciosa: PWA é uma melhoria progressiva, não deve
      // impedir o funcionamento normal do site se o registro falhar.
    });
  });
}
